export const gamesSlides = [
    {
        image: '/images/sliders/games/BG_DS-min.png',
        mobileImage: '/images/sliders/games/BG_DS_Mobile-min.png',
        video: '/images/animations/ds-thumb-video.mp4',
        mobileVideo: '/images/animations/ds-thumb-video-mobile.mp4',
        gameLogo: '/images/sliders/games/Logo_DS-min.png',
        gameDescription: 'Collect Dragonstone fragments and summon the Dragon for a shot at massive wins!',
        nextSlideStyleClass: 'next-slide-bg-1',
        nextSlideLogo: '/images/sliders/games/Logo_MA-min.png'
    },
    {
        image: '/images/sliders/games/BG_MA-min.png',
        mobileImage: '/images/sliders/games/BG_MA_Mobile-min.png',
        video: '/images/animations/ma-thumb-video.mp4',
        mobileVideo: '/images/animations/ma-thumb-video-mobile.mp4',
        gameLogo: '/images/sliders/games/Logo_MA-min.png',
        gameDescription: 'Dive into the jungle, uncover ancient riches, and redeem real prizes!',
        nextSlideStyleClass: 'next-slide-bg-2',
        nextSlideLogo: '/images/sliders/games/Logo_MBC-min.png'
    },
    {
        image: '/images/sliders/games/BG_MBC-min.png',
        mobileImage: '/images/sliders/games/BG_MBC_Mobile-min.png',
        video: '/images/animations/mbc-thumb-video.mp4',
        mobileVideo: '/images/animations/mbc-thumb-video-mobile.mp4',
        gameLogo: '/images/sliders/games/Logo_MBC-min.png',
        gameDescription: 'Play with up to 50 other players and be the last person to eject to win real prizes!',
        nextSlideStyleClass: 'next-slide-bg-3',
        nextSlideLogo: '/images/sliders/games/Logo_SX-min.png'
    },
    {
        image: '/images/sliders/games/BG_SX-min.png',
        mobileImage: '/images/sliders/games/BG_SX_Mobile-min.png',
        video: '/images/animations/sx-thumb-video.mp4',
        mobileVideo: '/images/animations/sx-thumb-video-mobile.mp4',
        gameLogo: '/images/sliders/games/Logo_SX-min.png',
        gameDescription: 'Go on an intergalactic adventure. Play against up to 5 players and beat the alien swarm.',
        nextSlideStyleClass: 'next-slide-bg-4',
        nextSlideLogo: '/images/sliders/games/Logo_DS-min.png'
    },
]